import { appConfig } from '../config/appConfig';

export interface ScaledImageTargetPose {
  scale?: number;
  scaledWidth?: number;
}

function positiveNumber(value: number | undefined): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}

/**
 * XR8 image target events report `scale` as the target's larger side in
 * current Three.js world units. `scaledWidth` converts that larger side back
 * to the target's normalized width, so configured meter offsets can stay
 * proportional even while XR8's absolute SLAM scale is settling.
 */
export function getImageTargetWorldWidth(pose: ScaledImageTargetPose): number {
  const eventScale = positiveNumber(pose.scale)
    ? pose.scale
    : appConfig.imageTargetPhysicalWidthM;
  const normalizedWidth = positiveNumber(pose.scaledWidth) ? pose.scaledWidth : 1;

  return eventScale * normalizedWidth;
}

export function getMetersToTargetWorldScale(pose: ScaledImageTargetPose): number {
  const configuredWidth = appConfig.imageTargetPhysicalWidthM;
  if (!positiveNumber(configuredWidth)) return 1;

  return getImageTargetWorldWidth(pose) / configuredWidth;
}
